import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard-overview',
    templateUrl: './dashboard-overview.component.html',
    styleUrls: ['./dashboard-overview.component.less'],
})
export class DashboardOverviewComponent {}